// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"618fb2b1035caafcc8e8","691":"8fecf294280608e0d139"}[chunkId] + ".js";
};